import { FC } from 'react';
import { Kalenderhändelse } from '../../types/pages';
import styles from './KalenderHändelse.module.css';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@kpa/kul';
import KalenderHändelseDatum from './KalenderHändelseDatum';
import KalenderHändelseContent from './KalenderHändelseContent';

type KalenderHändelseProps = {
  händelse: Kalenderhändelse;
};

const KalenderHändelse: FC<KalenderHändelseProps> = ({ händelse }) => {
  const nav = useNavigate();

  const redirect = (e: React.MouseEvent<HTMLAnchorElement | MouseEvent>, url: string) => {
    e.preventDefault();
    nav(url);
  };

  const GetLinkRad = () => {
    return (
      <a href={händelse.url} className={`${styles.container} ${styles.link}`} onClick={e => redirect(e, händelse.url)} rel="noopener noreferrer">
        <KalenderHändelseDatum händelse={händelse}></KalenderHändelseDatum>
        <div className={styles.content}>
          <KalenderHändelseContent händelse={händelse}></KalenderHändelseContent>
          <Icon name="IconCaretRight" className={styles.iconarrow} color="link" size="medium"></Icon>
        </div>
      </a>
    );
  };

  const GetNotisRad = () => {
    return (
      <div className={styles.container}>
        <KalenderHändelseDatum händelse={händelse}></KalenderHändelseDatum>
        <div className={styles.content}>
          <KalenderHändelseContent händelse={händelse}></KalenderHändelseContent>
        </div>
      </div>
    );
  };

  return händelse.notis
    ? GetNotisRad()
    : GetLinkRad();
};

export default KalenderHändelse;
